<div class="not-found-container">
    <div class="not-found-content">
        <!-- Animated floating document icon -->
        <div class="floating-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 100" class="doc-icon">
                <path d="M50 0H10C4.5 0 0 4.5 0 10v80c0 5.5 4.5 10 10 10h60c5.5 0 10-4.5 10-10V30L50 0z"
                      fill="var(--color-accent, #8ab3da)" opacity="0.15"/>
                <path d="M50 0H10C4.5 0 0 4.5 0 10v80c0 5.5 4.5 10 10 10h60c5.5 0 10-4.5 10-10V30L50 0z"
                      fill="none" stroke="var(--color-accent, #8ab3da)" stroke-width="2.5"/>
                <path d="M50 0v20c0 5.5 4.5 10 10 10h20" fill="none"
                      stroke="var(--color-accent, #8ab3da)" stroke-width="2.5"/>
                <!-- X mark on document -->
                <line x1="28" y1="50" x2="52" y2="74" stroke="var(--main-color, #585858)" stroke-width="4" stroke-linecap="round"/>
                <line x1="52" y1="50" x2="28" y2="74" stroke="var(--main-color, #585858)" stroke-width="4" stroke-linecap="round"/>
            </svg>
        </div>

        <h1 class="error-code">404</h1>
        <h2 class="error-title">Page Not Found</h2>
        <p class="error-message">
            The page you're looking for doesn't exist or has been moved. <br>
            Don't worry — let's get you back on track.
        </p>

        <a routerLink="/" class="btn btn-primary home-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            Back to Home
        </a>
    </div>
</div>
